import { createLayer, createLayerType, line } from "eutopia.ts";
import { $, resolve } from "signlets";

import type { State } from "../model";
import { blue } from "./color";

export type PathProps = {
  state: State | undefined;
};

export const path = createLayerType<PathProps>((context, { state }) => {
  const path = $(() => resolve(state)?.path ?? []);
  return createLayer(
    context,
    line({
      vertices: $(() => [
        path().map(position => ({
          position,
          color: blue,
          width: 1,
          minWidthPixels: 3,
        })),
      ]),
      polygonOffset: -1000,
    }),
  );
});
